export default {
  channels: state => state.channels,
  channelInfo: state => state.channelInfo,
  membership: state => state.membership,
  messages: state => state.messages,
  unreadCount: state => state.unreadCount,
  listener: state => state.listener,
  pubnub: state => state.pubnub,
  pubnubTimestamp: state => state.pubnubTimestamp,
  unreadCounts: state => state.unreadCounts,
  firmCounts: state => state.firmCounts,
  chatBar: state => state.chatBar
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/getters.js